import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { Expense } from '@webapp/modules/expense/entities/Expense'
import { expenseReportQueryConfig } from '@webapp/modules/expense/query-configs/expenseReport'

export const useQueryExpenseDetail = (uuid: string) => {
  const { data } = useQuery({
    ...expenseReportQueryConfig.detail(uuid),
  })

  const expense = useMemo(() => (data ? new Expense(data) : undefined), [data])

  return { expense }
}
